module.exports = __webpack_public_path__ + "static/media/20ECE2.efa90315.jpg";